import axios from 'axios';
import { api } from '../../app/conf';

export const uploadFiles = (file, token) => axios({
    method: 'post',
    url: `${api}/files/uploads`,
    headers: {
        "X-Access-Token": token,
    },
    data: file
});